import { useUpdateBrivoConnection } from '@/api/property-keyless/brivo/update-brivo-connection'

import { BrivoConnectionFormValues } from './brivo.schema'

export const useBrivoSubmit = (buildingId: number) => {
  const { mutateAsync, isPending } = useUpdateBrivoConnection()

  const submit = (values: BrivoConnectionFormValues) => mutateAsync({ buildingId, ...values })

  return { isPending, submit }
}
